/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Representation of product to show to the user
 * @export
 * @interface ProductCatalogueResponse
 */
export interface ProductCatalogueResponse {
    /**
     * 
     * @type {string}
     * @memberof ProductCatalogueResponse
     */
    uid?: string;
    /**
     * ServiceDefinitionV2.serviceDefinitionId
     * @type {string}
     * @memberof ProductCatalogueResponse
     */
    productId?: string;
    /**
     * ServiceDefinitionV2.serviceDefinitionName
     * @type {string}
     * @memberof ProductCatalogueResponse
     */
    productName?: string;
    /**
     * ServiceDefinitionV2.shortDescription
     * @type {string}
     * @memberof ProductCatalogueResponse
     */
    shortDescription?: string;
    /**
     * ServiceDefinitionV2.longDescription
     * @type {string}
     * @memberof ProductCatalogueResponse
     */
    longDescription?: string;
    /**
     * ServiceDefinitionV2.family
     * @type {string}
     * @memberof ProductCatalogueResponse
     */
    family?: string;
    /**
     * ServiceDefinitionV2.category
     * @type {string}
     * @memberof ProductCatalogueResponse
     */
    category?: string;
    /**
     * ServiceDefinitionV2.context
     * @type {string}
     * @memberof ProductCatalogueResponse
     */
    context?: string;
}

/**
 * Check if a given object implements the ProductCatalogueResponse interface.
 */
export function instanceOfProductCatalogueResponse(value: object): value is ProductCatalogueResponse {
    return true;
}

export function ProductCatalogueResponseFromJSON(json: any): ProductCatalogueResponse {
    return ProductCatalogueResponseFromJSONTyped(json, false);
}

export function ProductCatalogueResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductCatalogueResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'uid': json['uid'] == null ? undefined : json['uid'],
        'productId': json['productId'] == null ? undefined : json['productId'],
        'productName': json['productName'] == null ? undefined : json['productName'],
        'shortDescription': json['shortDescription'] == null ? undefined : json['shortDescription'],
        'longDescription': json['longDescription'] == null ? undefined : json['longDescription'],
        'family': json['family'] == null ? undefined : json['family'],
        'category': json['category'] == null ? undefined : json['category'],
        'context': json['context'] == null ? undefined : json['context'],
    };
}

export function ProductCatalogueResponseToJSON(json: any): ProductCatalogueResponse {
    return ProductCatalogueResponseToJSONTyped(json, false);
}

export function ProductCatalogueResponseToJSONTyped(value?: ProductCatalogueResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uid': value['uid'],
        'productId': value['productId'],
        'productName': value['productName'],
        'shortDescription': value['shortDescription'],
        'longDescription': value['longDescription'],
        'family': value['family'],
        'category': value['category'],
        'context': value['context'],
    };
}

